import http from "../../../../NetworkServices/http";

let consoleBaseUrl = process.env.REACT_APP_CH_CONSOLE_API_BASE_URL;
consoleBaseUrl = consoleBaseUrl + "api/v1";

export class AIServiceSettingsService {
  // Get AI Service Settings
  static getAIServiceSettings(params?: { search?: string; provider?: string; offset?: number; limit?: number }) {
    const queryParams = params ? new URLSearchParams(params as any).toString() : '';
    const url = queryParams ? `${consoleBaseUrl}${Endpoints.GET_AI_SERVICE_SETTINGS}?${queryParams}` : `${consoleBaseUrl}${Endpoints.GET_AI_SERVICE_SETTINGS}`;
    return http.get(url);
  }

  // Get AI Models
  static getAIModels() {
    return http.get(`${consoleBaseUrl}${Endpoints.GET_AI_MODELS}`);
  }

  // Save AI Service Settings
  static saveAIServiceSettings(data: any) {
    return http.post(`${consoleBaseUrl}${Endpoints.SAVE_AI_SERVICE_SETTINGS}`, data);
  }

  // Save API Key
  static saveApiKey(data: { model: string; apiKey?: string }) {
    return http.put(`${consoleBaseUrl}${Endpoints.SAVE_OPENROUTER_SETTINGS}`, data);
  }

  // Get API Key
  static getApiKey() {
    return http.get(`${consoleBaseUrl}${Endpoints.GET_API_KEY}`);
  }
  // Get AI Providers
  static getAIProviders() {
    return http.get(`${consoleBaseUrl}${Endpoints.GET_AI_PROVIDERS}`);
  }
  // Save OpenRouter Settings
  static saveOpenRouterSettings(data: { apiUrl: string; apiKey: string }) {
    return http.put(`${consoleBaseUrl}${Endpoints.PUT_OPENROUTER_SETTINGS}`, data);
  }
  // Get OpenRouter Settings
  static getOpenRouterSettings() {
    return http.get(`${consoleBaseUrl}${Endpoints.GET_OPENROUTER_SETTINGS}`);
  }
  static passOpenRouterSettings(data: { auto_router_enabled: boolean }) {
    return http.post(`${consoleBaseUrl}${Endpoints.SAVE_OPENROUTER_SETTINGS}`, data);
  }
  static deleteApiKey(data: { model: string; apiKey?: string }) {
    return http.delete(`${consoleBaseUrl}${Endpoints.DELETE_API_KEY}`, { data });
  }
}

// Label Endpoint
class Endpoints {
  static GET_AI_SERVICE_SETTINGS = "/workspace/openai/model-price";
  static GET_AI_MODELS = "/workspace/openai/model-price";
  static SAVE_AI_SERVICE_SETTINGS = "/workspace/openai/model-price";
  static GET_AI_PROVIDERS = "/workspace/openai/providers";
  static SAVE_API_KEY = "/workspace/openai/key";
  static GET_API_KEY = "/workspace/openai/key";
  static DELETE_API_KEY = "/workspace/openai/key";
  static SAVE_OPENROUTER_SETTINGS = "/workspace/openrouter";
  static GET_OPENROUTER_SETTINGS = "/workspace/openrouter";
  static PUT_OPENROUTER_SETTINGS = "/workspace/openrouter";


}